import { CarregamentoService } from './../../service/carregamento/carregamento.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoginRequest } from '../../models/request/login-request';
import { BehaviorSubject, catchError, finalize, take, takeWhile, tap, throwError, map } from 'rxjs';
import { LoginResponse } from '../../models/response/login-response';
import { BaseApi } from '../base-api';
import { AvisoService } from '../../service/aviso/aviso.service';
import { AdicionarSolicitacaoRequest } from '../../models/adicionar/adicionar-solicitacao';

@Injectable({
  providedIn: 'root'
})
export class AutenticacaoService extends BaseApi {
  private static readonly autenticado$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private static readonly sessaoUsuario$: BehaviorSubject<LoginResponse | null> = new BehaviorSubject<LoginResponse | null>(null);
  public static readonly usuario$ = AutenticacaoService.sessaoUsuario$.asObservable();

  controller: string = 'Autenticacao/';

  constructor(
    protected override http: HttpClient,
    protected override carregamentoService: CarregamentoService,
    private readonly AvisoService: AvisoService,
  ) {
    super(http, carregamentoService);
  }

  Login(model: LoginRequest) {
    return this.postJson(this.controller + 'Login', model).pipe(
      take(1),
      catchError((e) => {
        return throwError(() => e);
      }),
      tap((u: any) => {
        this.setarToken(u);
      })
    );
  }

  LogoutServidor() {
    let final = true;
    return this.postJsonWithoutLoading(this.controller + 'Logout', {}).pipe(
      takeWhile(() => final),
      finalize(() => final = false),
      map((baseResponse) => baseResponse)
    );
  }

  Logout() {
    localStorage.removeItem('usuarioId');
    localStorage.removeItem('perfil');
    localStorage.removeItem('vencimentoSessao');
    localStorage.removeItem('nivelDeAcesso');
    localStorage.removeItem('cpf');
    localStorage.removeItem('nome');
    localStorage.removeItem('rg');
    localStorage.removeItem('email');
    localStorage.removeItem('celular');
    localStorage.removeItem('nascimento');
    localStorage.removeItem('token');

    AutenticacaoService.autenticado$.next(false);
    AutenticacaoService.sessaoUsuario$.next(null);
  }

  setarToken(response: any) {
    if (response?.status && response.resultado) {
      AutenticacaoService.sessaoUsuario$.next(response.resultado);

      localStorage.setItem('usuarioId', response.resultado.usuarioId);
      localStorage.setItem('perfil', response.resultado.perfil);
      localStorage.setItem('vencimentoSessao', response.resultado.vencimentoSessao);
      localStorage.setItem('nivelDeAcesso', response.resultado.nivelDeAcesso);
      localStorage.setItem('cpf', response.resultado.cpf);
      localStorage.setItem('nome', response.resultado.nome);
      localStorage.setItem('rg', response.resultado.rg);
      localStorage.setItem('email', response.resultado.email);
      localStorage.setItem('celular', response.resultado.celular);
      localStorage.setItem('nascimento', response.resultado.nascimento);
      localStorage.setItem('token', response.mensagem);

      AutenticacaoService.autenticado$.next(true);
    }

    else if (response?.authenticated && response.accessToken) {
      localStorage.setItem('token', response.accessToken);
      localStorage.setItem('vencimentoSessao', response.expiration ?? '');

      if (response.user) {
        AutenticacaoService.sessaoUsuario$.next(response.user);
        sessionStorage.setItem('usuario', JSON.stringify(response.user));
      }

      AutenticacaoService.autenticado$.next(true);
    }
    else {
      this.AvisoService.Erro('Erro ao processar autenticação');
    }
  }

  BuscarUm(cpf: string) {
    let model = {
      cpf: cpf
    };
    let final = true;
    return this.postFormWithoutLoading(this.controller + 'BuscaUsuarioExistente', model).pipe(
      takeWhile(() => final),
      finalize(() => final = false),
      map((baseResponse) => baseResponse)
    );
  }

  ListarParaSelecao() {
    let final = true;
    return this.get(this.controller + 'ListarParaSelecao').pipe(
      takeWhile(() => final),
      finalize(() => final = false),
      map((baseResponse) => baseResponse)
    );
  }

  ListarTiposConvenios() {
    let final = true;
    return this.getWithoutLoading(this.controller + 'ListarTiposConvenios').pipe(
      takeWhile(() => final),
      finalize(() => final = false),
      map((baseResponse) => baseResponse)
    );
  }

  ListarMunicipios() {
    let final = true;
    return this.getWithoutLoading(this.controller + 'ListarMunicipios').pipe(
      takeWhile(() => final),
      finalize(() => final = false),
      map((baseResponse) => baseResponse)
    );
  }

  ListarCargos(instituicaoId: string) {
    let model = {
      instituicaoId: instituicaoId
    };
    let final = true;
    return this.postFormWithoutLoading(this.controller + 'ListarCargos', model).pipe(
      takeWhile(() => final),
      finalize(() => final = false),
      map((baseResponse) => baseResponse)
    );
  }

  ListarFuncoes(instituicaoId: string) {
    let model = {
      instituicaoId: instituicaoId
    };
    let final = true;
    return this.postFormWithoutLoading(this.controller + 'ListarFuncoes', model).pipe(
      takeWhile(() => final),
      finalize(() => final = false),
      map((baseResponse) => baseResponse)
    );
  }

  ListarUnidades(instituicaoId: string) {
    let model = {
      instituicaoId: instituicaoId
    };
    let final = true;
    return this.postFormWithoutLoading(this.controller + 'ListarUnidades', model).pipe(
      takeWhile(() => final),
      finalize(() => final = false),
      map((baseResponse) => baseResponse)
    );
  }

  Incluir(model: AdicionarSolicitacaoRequest) {
    let final = true;
    return this.postJson(this.controller + 'Incluir', model).pipe(
      takeWhile(() => final),
      finalize(() => final = false),
      map((baseResponse) => baseResponse)
    );
  }
}
